<template>
<div id="polaroid">
    
		<input class="element" type="text" name="name" id="name" placeholder="여기에 이름을 입력해 주세요.">
		<div style="width: 205px; border-bottom: 1px solid #ffffff; margin: 0px auto 3% auto; padding-bottom:8px">
    </div>
	
   
    <button id="generateColor" class="element" type="submit" v-on:click="generateColor()">
      색 만들기
    </button>
    
    <div id="result">
        <img id=" " src="@/assets/rectangle-desktop.png" width="129" height="154">
		<div id="colorRow">
		</div>
        <p id="inputName"></p>
    </div>
    
    <button id="downloadBtn" class="element" type="submit"  v-on:click="getImage()">
    </button>
    <div class="element" id="img-out" style="">
        <img id="output-clone" src="@/assets/rectangle-output.svg" width="387" height="471">
		<div id="colorRow-output">
		</div>
        <p id="inputName-output"></p>

		<p id="hashTag"># 내 이름에 담긴 색</p>
	</div>
	<div id="outputContainer" ></div>

</div>
</template>

<script>
import html2canvas from 'html2canvas';
import * as Hangul from 'hangul-js';
import * as domtoimage from 'dom-to-image'
import {  } from "file-saver";
import $ from 'jquery';
/**
 * covert canvas to image
 * and save the image file
 */

var Canvas2Image = function () {

	// check if support sth.
	var $support = function () {
		var canvas = document.createElement('canvas'),
			ctx = canvas.getContext('2d');

		return {
			canvas: !!ctx,
			imageData: !!ctx.getImageData,
			dataURL: !!canvas.toDataURL,
			btoa: !!window.btoa
		};
	}();

	var downloadMime = 'image/octet-stream';

	function scaleCanvas (canvas, width, height) {
		var w = canvas.width,
			h = canvas.height;
		if (width == undefined) {
			width = w;
		}
		if (height == undefined) {
			height = h;
		}

		var retCanvas = document.createElement('canvas');
		var retCtx = retCanvas.getContext('2d');
		retCanvas.width = width;
		retCanvas.height = height;
		retCtx.drawImage(canvas, 0, 0, w, h, 0, 0, width, height);
		return retCanvas;
	}

	function getDataURL (canvas, type, width, height) {
		canvas = scaleCanvas(canvas, width, height);
		return canvas.toDataURL(type);
	}

	function saveFile (strData) {
    // document.location.href = strData;
    window.open(strData,"strData");
	}

	function genImage(strData) {
		var img = document.createElement('img');
		img.src = strData;
		return img;
	}
	function fixType (type) {
		type = type.toLowerCase().replace(/jpg/i, 'jpeg');
		var r = type.match(/png|jpeg|bmp|gif/)[0];
		return 'image/' + r;
	}
	function encodeData (data) {
		if (!window.btoa) { throw 'btoa undefined' }
		var str = '';
		if (typeof data == 'string') {
			str = data;
		} else {
			for (var i = 0; i < data.length; i ++) {
				str += String.fromCharCode(data[i]);
			}
		}

		return btoa(str);
	}
	function getImageData (canvas) {
		var w = canvas.width,
			h = canvas.height;
		return canvas.getContext('2d').getImageData(0, 0, w, h);
	}
	function makeURI (strData, type) {
		return 'data:' + type + ';base64,' + strData;
	}


	/**
	 * create bitmap image
	 * 按照规则生成图片响应头和响应体
	 */
	var genBitmapImage = function (oData) {

		//
		// BITMAPFILEHEADER: http://msdn.microsoft.com/en-us/library/windows/desktop/dd183374(v=vs.85).aspx
		// BITMAPINFOHEADER: http://msdn.microsoft.com/en-us/library/dd183376.aspx
		//

		var biWidth  = oData.width;
		var biHeight	= oData.height;
		var biSizeImage = biWidth * biHeight * 3;
		var bfSize  = biSizeImage + 54; // total header size = 54 bytes

		//
		//  typedef struct tagBITMAPFILEHEADER {
		//  	WORD bfType;
		//  	DWORD bfSize;
		//  	WORD bfReserved1;
		//  	WORD bfReserved2;
		//  	DWORD bfOffBits;
		//  } BITMAPFILEHEADER;
		//
		var BITMAPFILEHEADER = [
			// WORD bfType -- The file type signature; must be "BM"
			0x42, 0x4D,
			// DWORD bfSize -- The size, in bytes, of the bitmap file
			bfSize & 0xff, bfSize >> 8 & 0xff, bfSize >> 16 & 0xff, bfSize >> 24 & 0xff,
			// WORD bfReserved1 -- Reserved; must be zero
			0, 0,
			// WORD bfReserved2 -- Reserved; must be zero
			0, 0,
			// DWORD bfOffBits -- The offset, in bytes, from the beginning of the BITMAPFILEHEADER structure to the bitmap bits.
			54, 0, 0, 0
		];

		//
		//  typedef struct tagBITMAPINFOHEADER {
		//  	DWORD biSize;
		//  	LONG  biWidth;
		//  	LONG  biHeight;
		//  	WORD  biPlanes;
		//  	WORD  biBitCount;
		//  	DWORD biCompression;
		//  	DWORD biSizeImage;
		//  	LONG  biXPelsPerMeter;
		//  	LONG  biYPelsPerMeter;
		//  	DWORD biClrUsed;
		//  	DWORD biClrImportant;
		//  } BITMAPINFOHEADER, *PBITMAPINFOHEADER;
		//
		var BITMAPINFOHEADER = [
			// DWORD biSize -- The number of bytes required by the structure
			40, 0, 0, 0,
			// LONG biWidth -- The width of the bitmap, in pixels
			biWidth & 0xff, biWidth >> 8 & 0xff, biWidth >> 16 & 0xff, biWidth >> 24 & 0xff,
			// LONG biHeight -- The height of the bitmap, in pixels
			biHeight & 0xff, biHeight >> 8  & 0xff, biHeight >> 16 & 0xff, biHeight >> 24 & 0xff,
			// WORD biPlanes -- The number of planes for the target device. This value must be set to 1
			1, 0,
			// WORD biBitCount -- The number of bits-per-pixel, 24 bits-per-pixel -- the bitmap
			// has a maximum of 2^24 colors (16777216, Truecolor)
			24, 0,
			// DWORD biCompression -- The type of compression, BI_RGB (code 0) -- uncompressed
			0, 0, 0, 0,
			// DWORD biSizeImage -- The size, in bytes, of the image. This may be set to zero for BI_RGB bitmaps
			biSizeImage & 0xff, biSizeImage >> 8 & 0xff, biSizeImage >> 16 & 0xff, biSizeImage >> 24 & 0xff,
			// LONG biXPelsPerMeter, unused
			0,0,0,0,
			// LONG biYPelsPerMeter, unused
			0,0,0,0,
			// DWORD biClrUsed, the number of color indexes of palette, unused
			0,0,0,0,
			// DWORD biClrImportant, unused
			0,0,0,0
		];

		var iPadding = (4 - ((biWidth * 3) % 4)) % 4;

		var aImgData = oData.data;

		var strPixelData = '';
		var biWidth4 = biWidth<<2;
		var y = biHeight;
		var fromCharCode = String.fromCharCode;

		do {
			var iOffsetY = biWidth4*(y-1);
			var strPixelRow = '';
			for (var x = 0; x < biWidth; x++) {
				var iOffsetX = x<<2;
				strPixelRow += fromCharCode(aImgData[iOffsetY+iOffsetX+2]) + fromCharCode(aImgData[iOffsetY+iOffsetX+1]) + fromCharCode(aImgData[iOffsetY+iOffsetX]);
			}

			for (var c = 0; c < iPadding; c++) {
				strPixelRow += String.fromCharCode(0);
			}

			strPixelData += strPixelRow;
		} while (--y);

		var strEncoded = encodeData(BITMAPFILEHEADER.concat(BITMAPINFOHEADER)) + encodeData(strPixelData);

		return strEncoded;
	};

	/**
	 * saveAsImage
	 * @param canvasElement
	 * @param {String} image type
	 * @param {Number} [optional] png width
	 * @param {Number} [optional] png height
	 */
	var saveAsImage = function (canvas, width, height, type) {
		if ($support.canvas && $support.dataURL) {
			if (typeof canvas == "string") { canvas = document.getElementById(canvas); }
			if (type == undefined) { type = 'png'; }
      type = fixType(type);
      var strData;
			if (/bmp/.test(type)) {
				var data = getImageData(scaleCanvas(canvas, width, height));
				strData = genBitmapImage(data);
				saveFile(makeURI(strData, downloadMime));
			} else {
				strData = getDataURL(canvas, type, width, height);
				saveFile(strData.replace(type, downloadMime));
			}
		}
	};

	var convertToImage = function (canvas, width, height, type) {
		if ($support.canvas && $support.dataURL) {
			if (typeof canvas == "string") { canvas = document.getElementById(canvas); }
			if (type == undefined) { type = 'png'; }
			type = fixType(type);
      var strData;
			if (/bmp/.test(type)) {
				var data = getImageData(scaleCanvas(canvas, width, height));
				strData = genBitmapImage(data);
				return genImage(makeURI(strData, 'image/bmp'));
			} else {
				strData = getDataURL(canvas, type, width, height);
				return genImage(strData);
			}
		}
	};



	return {
		saveAsImage: saveAsImage,
		saveAsPNG: function (canvas, width, height) {
			return saveAsImage(canvas, width, height, 'png');
		},
		saveAsJPEG: function (canvas, width, height) {
			return saveAsImage(canvas, width, height, 'jpeg');
		},
		saveAsGIF: function (canvas, width, height) {
			return saveAsImage(canvas, width, height, 'gif');
		},
		saveAsBMP: function (canvas, width, height) {
			return saveAsImage(canvas, width, height, 'bmp');
		},

		convertToImage: convertToImage,
		convertToPNG: function (canvas, width, height) {
			return convertToImage(canvas, width, height, 'png');
		},
		convertToJPEG: function (canvas, width, height) {
			return convertToImage(canvas, width, height, 'jpeg');
		},
		convertToGIF: function (canvas, width, height) {
			return convertToImage(canvas, width, height, 'gif');
		},
		convertToBMP: function (canvas, width, height) {
			return convertToImage(canvas, width, height, 'bmp');
		}
	};

}();

export default {
  name: 'ColorGenerator',
  props: {
    msg: String
  },
  methods:{
      
      getImage:function(){
        var result = document.getElementById("img-out");
		result;
		Canvas2Image;
		html2canvas;
		domtoimage.toBlob(result).then(function(blob){
			window.saveAs(blob, 'result.png');
		})
        // html2canvas(result).then(function(canvas){
        //     document.getElementById("outputContainer").innerHTML="";
        //     document.getElementById("outputContainer").appendChild(canvas);
        //     // canvas;
        // }).then(()=>{
        //     let imageOutput = document.getElementById("outputContainer");
        //     let targetedCanvas = imageOutput.childNodes[0];
        //     Canvas2Image.saveAsImage(targetedCanvas, 1080, 1920, 'bmp');
        // })
      },

      generateColor:function(){
		//   To-do
		let colorContainer = document.getElementById("colorRow");
		let cloneContainer = document.getElementById("colorRow-output");
		
		let nameContainer = document.getElementById("inputName");
		let nameClone = document.getElementById("inputName-output");
		
		var input = document.getElementById("name").value;
		input = input.replace(/ /gi, "");
		
		let colorDict = {
			'ㄱ': "#002F53",
			'ㄴ': "#2D999F",
			'ㄷ': "#EEE9E0",
			'ㄹ': "#D8D8C2",
			'ㅁ': "#F25D50",
			'ㅂ': "#F29727",
			'ㅅ': "#804D4D",
			'ㅇ': "#FF9B99",
			'ㅈ': "#FFE6E5",
			'ㅊ': "#F1C059",
			'ㅋ': "#DC212A",
			'ㅌ': "#0F4C81",
			'ㅍ': "#FF0D74",
			'ㅎ': "#E80CD8",
			'ㅏ': "#C501FF",
			'ㅑ': "#780CE8",
			'ㅓ': "#420DFF",
			'ㅕ': "#FFD1CE",
			'ㅗ': "#FFA2C0",
			'ㅛ': "#8B92FF",
			'ㅜ': "#FFD4C9",
			'ㅠ': "#FFBBB6",
			'ㅡ': "#425C59",
			'ㅣ': "#FF0077",
			'ㅔ': "#A2BFBE",
			'ㅐ': "#555C5A",
			'ㅒ': "#2D3773",
			'ㅖ': "#F26A4B",
			'ㅘ': "#F23D3D",
			'ㅝ': "#FEEDD0",
			'ㅙ': "#530630",
			'ㅞ': "#FFDE4D",
			'ㅢ': "#FF9060",
			'ㅟ': "#F25244",
			'ㅚ': "#E884DB",
			'ㄲ': "#EC9EFF",
			'ㄸ': "#B984E8",
			'ㅃ': "#AD91FF",
			'ㅆ': "#FF0077",
			'ㅉ': "#E884DB",
			
		};
		colorDict;
		nameContainer.innerHTML = input;
		nameClone.innerHTML = input;
		
		colorContainer;

		// alert(Hangul.disassemble(input));
		
		var disasm = Hangul.disassemble(input);
		var prevChar;
		var disasm_result = [];
		
		disasm.forEach(element => {

			if(Hangul.isVowel(element)){
				if(Hangul.isVowel(prevChar)){
					var actualVowel;
					switch (prevChar) {
						case 'ㅗ':
							if(element == 'ㅏ')
								actualVowel = 'ㅘ';
							else if (element == 'ㅐ')
								actualVowel = 'ㅙ';
							else if (element == 'ㅣ')
								actualVowel = 'ㅚ';
							else{
								alert("입력하신 이름이 이상해요.")
								return;
							}
							break;

						case 'ㅜ':
							if(element == 'ㅓ')
								actualVowel = 'ㅝ';
							else if (element == 'ㅔ')
								actualVowel = 'ㅞ';
							else if (element == 'ㅣ')
								actualVowel = 'ㅟ';
							else{
								alert("입력하신 이름이 이상해요.")
								return;
							}
							break;

						case 'ㅡ':
							if(element == 'ㅣ')
								actualVowel = 'ㅢ';
							else{
								alert("입력하신 이름이 이상해요.")
								return;
							}
							break;
					
						default:
							break;
					}
					disasm_result.pop();
					disasm_result.push(actualVowel);
				}
				disasm_result.push(element);

			}else if(Hangul.isCho(element)){
				disasm_result.push(element);
			}else{
				// alert("입력하신 이름이 이상해요.")
				return;				
			}	
			prevChar = element;
		});
		
		

		var divCounter = 0;
		var columnWidth = 110/disasm_result.length;
		var cloneWidth = 340/disasm_result.length;
		
		
		disasm_result.forEach(element => {
			
			var div = document.createElement('div');
			// div.id = 'colorColumn';
			div.style.width = (111 - divCounter*columnWidth) +"px";
			div.style.height = "111px";
			// div.style.margin = "auto"
			div.style.position = "absolute"
			div.style.left = (9 + divCounter*columnWidth) + "px";
			div.style.top = "11px";
			if(colorDict[element]){
				div.style.backgroundColor = colorDict[element];
			}
			var div_clone = document.createElement('div');
			// div.id = 'colorColumn';
			div_clone.style.width = (340 - divCounter*cloneWidth) +"px";
			div_clone.style.height = "340px";
			// div.style.margin = "auto"
			div_clone.style.position = "absolute"
			div_clone.style.left = (29 + divCounter*cloneWidth) + "px";
			div_clone.style.right = "0px"
			div_clone.style.top = "676px";
			if(colorDict[element]){
				div_clone.style.backgroundColor = colorDict[element];
			}

			divCounter++;

			colorContainer.appendChild(div);
			cloneContainer.appendChild(div_clone);

		});

		$("widget");
        // let canvas = document.getElementById("widget");
        // Canvas2Image

        // $('img-out').appendChild(Canvas2Image.convertToImage(canvas, 0, 0))

    }
    

  },
  mounted(){
      
  }
}

</script>

<style scoped>
input, textarea, select {
    font-family:inherit;
    text-align: center;
}
input:focus, textarea:focus, select:focus {
border: 1px solid transparent !important;
box-shadow: 0 0 3px transparent !important;
-moz-box-shadow: 0 0 3px transparent !important;
-webkit-box-shadow: 0 0 3px transparent !important;
}
input:focus, textarea:focus, select:focus {
outline-offset: 0px !important;
outline: none !important;
}
::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #ffffff;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: #ffffff;
}

::-ms-input-placeholder { /* Microsoft Edge */
  color: #ffffff;
}

input#name{
	width:234px;
    background-color: transparent;
    color: #ffffff;
    border: transparent;
	margin: 0 auto;
	font-size: 16px;	
}

.element{
    display: block;
    margin: 0 auto;
}

#result{
    margin: 0 auto;
    max-width: 129px;
    max-height: 154px;
	position: relative;
	margin-bottom: 41px;
    /* min-width: 129px;
    min-height: 154px; */
}
#polaroid{
	position: relative;
    margin: 0 auto;
    justify-content: center;
    align-content: center;
    padding: 0px;
}
canvas{
    margin: 0 auto;
    padding: 0px;
}
#inputName{
	position: absolute;
	bottom: 12px;
	width: 129px;
	margin: 0 auto;
    justify-content: center;
    align-content: center;
    font-size: 10px;
	text-align: center;
	color: #121212;
}

#inputName-output{
	position: absolute;
	bottom: 840px;
	width: 200px;
	margin: 0 auto;
	left: 440px;
    justify-content: center;
    align-content: center;
    font-size: 28px;
	text-align: center;
	color: #121212;
}
button{
  font-family: 'Noto Serif KR', serif !important;
}
#generateColor{
	width: 107px;
	height: 33px;
	background: url("~@/assets/chooseColor.svg") no-repeat;
	cursor: pointer;
	border: none;
	margin-bottom: 7%;
}
#downloadBtn{
	width: 18px;
	height: 20px;
	background: url("~@/assets/download.png") no-repeat;
	object-fit: contain;
	cursor: pointer;
	border: none;
	margin-bottom: 216px;
}
#output-clone{
	/* width: 1080px; */
	/* height: 1920px; */
	margin-top: 648px;
	position: relative;
}
#colorRow-output{
	margin: 0px auto;
	position: absolute;
	top: 0px;
	left: 341px;
	padding: 0px auto;
}

#img-out{
	background: #121212;
	position: relative;
	width: 1080px;
	height: 1920px;
    margin: 0px;
    padding: 0px;
	justify-content: center;
	align-content: center;

    /* display: none; */
}
#hashTag{
	font-family: 'Noto Serif KR';
	width: 360px;
	height: 50px;
	object-fit: contain;
	font-size: 35px;
	font-weight: bold;
	font-stretch: normal;
	margin: 129px auto;
	color: #ffffff;
	text-align: center;
}
</style>